import React from 'react'

import { Image } from 'react-native'

const Logo = ({ logoURL }: { logoURL: string }) => (
  <Image resizeMode="contain" source={{ uri: logoURL, width: 200, height: 40 }} />
)

export default Logo
